/**
 * Quiz Lead Funnel Flag Updates
 * ==============================
 * Fire-and-forget updates to quiz_leads table funnel flags.
 * Uses session_id from localStorage 'nathof_lead_identity' as the key.
 */

import { supabase } from '@/integrations/supabase/client';

type FunnelFlag = 'quiz_started' | 'quiz_completed' | 'checkout_started' | 'purchase_completed';

/**
 * Retrieves the session_id from the lead identity stored in localStorage.
 */
export function getQuizLeadSessionId(): string | null {
  try {
    const raw = localStorage.getItem('nathof_lead_identity');
    if (raw) {
      const identity = JSON.parse(raw);
      return identity?.session_id || null;
    }
  } catch { /* ignore */ }
  return null;
}

/**
 * Fire-and-forget update of a funnel flag on quiz_leads by session_id.
 */
export function updateQuizLeadFunnel(flag: FunnelFlag): void {
  const sessionId = getQuizLeadSessionId();
  if (!sessionId) return;

  supabase
    .from('quiz_leads')
    .update({ [flag]: true })
    .eq('session_id', sessionId)
    .then(({ error }) => {
      if (error && import.meta.env.DEV) {
        console.warn(`[QuizLead] update ${flag} failed:`, error.message);
      }
    });
}
